import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { UserNotificationTypeEnum, useUserNotificationSubscriptionSubscription } from "generated/graphql";
import { useApolloClientStore } from "stores/useApolloClientStore";
import { useReportDownloadStore } from "stores/useReportDownloadStore";
import { downloadFile } from "utils/downloadFile";

const UserNotificationSubscription: React.FC = () => {
  const { t } = useTranslation();

  const { isApolloClientReady } = useApolloClientStore();

  const { reportRequestIds, setReportRequestIds } = useReportDownloadStore(state => ({
    reportRequestIds: state.reportRequestIds,
    setReportRequestIds: state.setReportRequestIds,
  }));

  useUserNotificationSubscriptionSubscription({
    skip: !isApolloClientReady,
    onData: ({ data }) => {
      if (data?.data?.userNotification) {
        const { type, reportRequest } = data.data.userNotification;

        if (type === UserNotificationTypeEnum.ReportRequest) {
          const { id: reportRequestId, fileUrl, report } = reportRequest ?? {};

          if (!reportRequestId) {
            return;
          }

          if (!reportRequestIds.has(reportRequestId)) {
            return;
          }

          if (fileUrl) {
            downloadFile(
              fileUrl,
              `${report?.name}-${report?.reportGroup?.reference}-${Date.now()}.xlsx`.trim().toLowerCase(),
            );

            const newSet = new Set(reportRequestIds);
            newSet.delete(reportRequestId);
            setReportRequestIds(newSet);

            toast.success(t("operations.exporting_excel_success"));
          } else {
            toast.error(t("operations.exporting_excel_error"));
          }
        }
      }
    },
    onError: error => {
      toast.error(error.message);
    },
  });

  return <></>;
};

export default UserNotificationSubscription;
